/*
 * @Description: 
 * @Author: dinghao
 * @Date: 2022-03-28 13:37:26
 * @LastEditTime: 2022-03-28 13:46:02
 * @LastEditors: dinghao
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Axios from 'axios'

import BaiduMap from 'vue-baidu-map'
import Vant from 'vant';
import 'vant/lib/index.css';
import iView from 'iview';
import 'iview/dist/styles/iview.css'
import {VueJsonp} from "vue-jsonp"
Vue.use(VueJsonp)
Vue.use(Vant);
Vue.use(iView);

Vue.prototype.$api = Axios
// Vue.use(BaiduMap, { ak: 'DEMO_MAP' })
Vue.use(BaiduMap, { ak: 'OXXA6H5lGyj3r5Bao3OP6gHH3FRUiGjz' })

Vue.config.productionTip = false

new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
